import { render } from "./PasswordRecoveryModal.vue?vue&type=template&id=8ecbef78&scoped=true&ts=true&lang=pug"
import script from "./PasswordRecoveryModal.vue?vue&type=script&lang=ts"
export * from "./PasswordRecoveryModal.vue?vue&type=script&lang=ts"

import "./PasswordRecoveryModal.vue?vue&type=style&index=0&id=8ecbef78&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/WP Darts/Admin Webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ecbef78"]])

export default __exports__